





















































































































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from "vue-property-decorator";

//@ts-ignore
import dependencias from "@/mixins/axios/general_secretarias";

//@ts-ignore
import departamentos from "@/mixins/axios/general_departamentos";

//@ts-ignore
import poa_lineas_accion from "@/mixins/axios/poa_lineas_accion";
//@ts-ignore
import indicador_administradores from "@/mixins/axios/indicador_administradores";

//@ts-ignore
import indicador_variables from '@/mixins/axios/indicador_variables'

//@ts-ignore
import TablePPoa from "@/components/tables/tablev1";
//@ts-ignore
import { email, required } from "vuelidate/lib/validators";
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'
import OrganizationChart from "vue-organization-chart";
import "vue-organization-chart/dist/orgchart.css";
import VueHtml2pdf from "vue-html2pdf";
import bootstrap from "!raw-loader!./bootstrap.css";
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'
import VueAxios from "vue-axios";
import axios from "axios";
@Component({
  components: {OrganizationChart},

  data() {
    return {
      //Linea Accion
 
        variables_indicadores:[] as any,
 indicador_variablesdata:[] as any,
   selectedvar:0,
     
    };
  },
  mixins: [
  indicador_variables,
  indicador_administradores
  ],
  methods: { AsingarVariable(){
          if(this.selectedvar!=0){
let data=this.indicador_variablesdata.filter(item => item.id ==this.selectedvar)[0];
let variable={
indicador_variables_id:data.id
};
 this.variables_indicadores.push(variable);
          }

         
      },
searchVar(id){
  
    if(this.variables_indicadores.filter(item => item.indicador_variables_id ==id).length>0){
        return true;

    }else{
        return false;
    }
    
},
async getVariables() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_INDICADOR_VARIABLES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_variablesdata=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
  async onClick() {
       var sTable = document.getElementById('tablaIndicador').innerHTML;
              await axios({
                    url: this.$store.state.baseapi+"pdf",
                    method: 'POST',
                    data:{
                      html:sTable,
                      title:"Ficha Indicador",
                       id:this.$store.state.user.usuario.id_municipio
                    },
                      headers: { 
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
                    responseType: 'blob'
                }).then((response) => {
                     var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                     var fileLink = document.createElement('a');

                     fileLink.href = fileURL;
                     fileLink.setAttribute('download', 'file.pdf');
                     document.body.appendChild(fileLink);

                     fileLink.click();
                });
          },
          async getIndicador() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')
let data2={
id:this.$store.state.indicador_administrador_sel.id,

};


let data= await this.GET_ADMINISTRADORESHOW(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                       //this.problema_select=response; 

this.variables_indicadores=response.variables_indicadores;
console.log(this.variables_indicadores);
            

//console.log(response)
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
  
  },
  created() {},
  mounted() {
          this.getVariables();   this.getIndicador();
   /// this.getDataActividadLinea();
    //this.getDataAvanceFisico();
   // getDataAvanceFinanciero();
  },
})
export default class Home extends Vue {}
